module.exports = __webpack_public_path__ + "static/media/blank-profile-picture-973460_1280.a5369809.webp";